module.exports = __webpack_public_path__ + "static/media/folder-disable.fba35f3c.svg";